import { CredentialManagementService } from './../../../../auth/credentials.service';
import { Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, TokenService } from '@demoiselle/security';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeader {

  tokenData: null;

  constructor(
    private el: ElementRef,
    private router: Router,
    private authService: AuthService,
    private tokenService: TokenService) { }

  //wait for the component to render completely
  ngOnInit(): void {
    if (this.tokenService.isAuthenticated()) {
      this.tokenData = this.tokenService.getDataFromToken();
    }
    var nativeElement: HTMLElement = this.el.nativeElement,
    parentElement: HTMLElement = nativeElement.parentElement;
    // move all children out of the element
    while (nativeElement.firstChild) {
      parentElement.insertBefore(nativeElement.firstChild, nativeElement);
    }
    // remove the empty element(the host)
    parentElement.removeChild(nativeElement);
  }

  isLoggedIn() {
    return this.authService.isAuthenticated();
  }

  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/login');
  }
}



// WEBPACK FOOTER //
// /builds/sggd-10899/troca-senha-frontend/frontend/src/app/shared/layout/components/app-header/app-header.component.ts